// מנוע ה-AI של החברה בצד השרת (node, מודול /api/ai) — המפתח המוצפן מ-CompanyAiKeys.
// משלים את המפתחות ששמורים בדפדפן (berry.integrations.center.v1): מפתח שנשמר
// בשרת ממסך החיבורים זמין לכל המשתמשים בחברה ולכל דפדפן, בלי שהוא יוצא מהשרת.
import { axiosServerNodeServices } from 'utils/axios';

export type CompanyAiProvider = 'anthropic' | 'google';

export interface CompanyAiStatus {
  status: 'ready' | 'misconfigured';
  provider: CompanyAiProvider | null;
  model: string | null;
}

interface Envelope<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export type SupportChatTurn = { role: 'user' | 'assistant'; content: string };

function extractError(err: unknown): { code: string; message: string } {
  //* ה-interceptor של axios דוחה עם גוף התשובה עצמו, לא עם AxiosError (ראה company-ai-keys)
  const raw = (err as any)?.response?.data ?? err;
  const resp = raw && typeof raw === 'object' && !(raw instanceof Error) ? (raw as any) : null;
  return {
    code: resp?.error ?? 'NETWORK',
    message: resp?.message ?? (err instanceof Error ? err.message : 'הפעולה נכשלה — בדקו את החיבור ונסו שוב'),
  };
}

/** GET /api/ai/status — איזה מנוע (אם בכלל) מחובר לחברה. פתוח לכל משתמש מחובר. */
export async function getCompanyAiStatus(): Promise<
  { ok: true; status: CompanyAiStatus } | { ok: false; code: string; message: string }
> {
  try {
    const { data } = await axiosServerNodeServices.get<Envelope<CompanyAiStatus>>('/api/ai/status');
    const status = data.data;
    if (!status) return { ok: false, code: 'EMPTY', message: 'empty status' };
    return { ok: true, status };
  } catch (err) {
    return { ok: false, ...extractError(err) };
  }
}

/** POST /api/ai/support-chat — סבב שיחה של עוזר התמיכה על מפתח החברה שבשרת. */
export async function askCompanyAiSupportChat(params: {
  systemPrompt: string;
  turns: SupportChatTurn[];
}): Promise<
  { ok: true; text: string; provider: CompanyAiProvider; model: string } | { ok: false; code: string; message: string }
> {
  try {
    const { data } = await axiosServerNodeServices.post<
      Envelope<{ text: string; provider: CompanyAiProvider; model: string }>
    >('/api/ai/support-chat', params);
    if (!data.data) return { ok: false, code: 'EMPTY', message: 'empty response' };
    return { ok: true, ...data.data };
  } catch (err) {
    return { ok: false, ...extractError(err) };
  }
}
